import { BaseAPI } from "@utils/base-api";
import { OrderReceiptDto } from "@./types/orders/dto/OrderReciept.dto";
import { SerialType } from "@utils/types";

import { IOrderLineItemResponse } from "./types/orders";

export interface HasNibblesRecentlyResponse {
  hasPurchasedNibbles: boolean;
  lastOrderDate: string | null;
}

export class OrdersAPI extends BaseAPI {

  public async hasPurchasedNibblesInXMonths(months: number): Promise<HasNibblesRecentlyResponse> {
    const result = await this.axios.get<HasNibblesRecentlyResponse>(
      "/orders/nibbles/purchased-within",
      {
        params: { months },
      },
    );
    return result.data;
  }

  public async getAllOrderReceipts(): Promise<SerialType<OrderReceiptDto[]>> {
    const result = await this.axios.get(
      "/customer/orders/receipts/all",
    );
    return result.data;
  }

  public async getOrderReceipt(orderId: number): Promise<SerialType<OrderReceiptDto>> {
    const result = await this.axios.get(
      `/customer/orders/receipts/${orderId}`,
    );
    return result.data;
  }

  public async getAllOrderLineItems(): Promise<IOrderLineItemResponse | null[]> {
    const result = await this.axios.get(
      "/customer/orders/items/all",
    );
    return result.data;
  }

  public async getLastOrderLineItems(): Promise<IOrderLineItemResponse | null> {
    const result = await this.axios.get(
      "/customer/orders/items/last",
    );
    return result.data;
  }

  public async hadHalloweenRecipe(subscriptionId: number): Promise<boolean> {
    const result = await this.axios.get(
      `/customer/orders/had-halloween-recipe/${subscriptionId}`,
    );
    return result.data;
  }

  public async hadXmasRecipe(subscriptionId: number): Promise<boolean> {
    const result = await this.axios.get(
      `/customer/orders/had-xmas-recipe/${subscriptionId}`,
    );
    return result.data;
  }

}
